import React, { Component } from 'react';
import { Input, Icon } from 'antd';

import { inject, observer } from 'mobx-react';

import { MagnifierIcon } from '../../../../../common/icons';

import './FullTextSearch.css';

@inject('carsStore', 'filterStore')
@observer
export default class FullTextSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fullTextSearch: ''
    }
  }

  componentWillUnmount = () => {
    this.emitEmpty();
  };

  search = () => {
    this.props.onFullTextSearch(this.state.fullTextSearch);
  };

  keyPress = e => {
    if (e.keyCode === 13) {
      this.search();
    }
  };

  emitEmpty = () => {
    this.setState({ fullTextSearch: "" });
    this.props.onClearFullTextSearch();
  };

  onChange = e => {
    this.setState({ fullTextSearch: e.target.value });
  };

  render() {
    const suffix = this.state.fullTextSearch ? <Icon type="close-circle" onClick={this.emitEmpty} style={{ color: 'white' }} /> : null;
    return (
      <div className="FullTextSearch">
        <Input
          placeholder={this.props.placeholder}
          prefix={<MagnifierIcon onClick={this.search} />}
          value={this.state.fullTextSearch}
          onChange={this.onChange}
          onKeyDown={this.keyPress}
          suffix={suffix}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/Dashboard/SubHeader/FullTextSearch/FullTextSearch.js